import { create } from 'zustand';

interface SessionTrackerStore {
    lastViewedTransactionEntryId: string | null | undefined;
    setLastViewedTransactionEntryId: (id: string | null | undefined) => void;
    lastViewedTransactionEntryIdTimestamp: number | null;
}

export const useSessionTrackerStore = create<SessionTrackerStore>((set) => ({
    lastViewedTransactionEntryId: null,
    lastViewedTransactionEntryIdTimestamp: null,
    setLastViewedTransactionEntryId: (id) =>
        set({
            lastViewedTransactionEntryId: id,
            lastViewedTransactionEntryIdTimestamp: id ? Date.now() : null,
        }),
}));

const EXPIRATION_HOURS = 24;

// Keep track of the last viewed transaction entry ID for the length of the session
// This allows us to highlight the last viewed transaction from the start of their
// session, even if the user navigates away and back
// If the user navigates away and back after 24 hours, we will reset the last viewed transaction
export const getLastViewedTransactionEntryIdForSession = (
    currentLastViewedTransactionEntryId: string | null | undefined
) => {
    const state = useSessionTrackerStore.getState();

    // Check if the stored ID has expired
    if (state.lastViewedTransactionEntryIdTimestamp) {
        const expirationTime =
            state.lastViewedTransactionEntryIdTimestamp +
            EXPIRATION_HOURS * 60 * 60 * 1000;

        if (Date.now() > expirationTime) {
            state.setLastViewedTransactionEntryId(null);
        }
    }

    if (
        state.lastViewedTransactionEntryId === null &&
        currentLastViewedTransactionEntryId
    ) {
        state.setLastViewedTransactionEntryId(
            currentLastViewedTransactionEntryId
        );
    }

    return state.lastViewedTransactionEntryId;
};

export const resetLastViewedTransactionEntryIdForSession = () => {
    const state = useSessionTrackerStore.getState();
    state.setLastViewedTransactionEntryId(null);
};
